import { EngineCache } from './engineCache'

/**
 * Cache all rules engines by engagement template ID.
 */
export default new EngineCache()
